import { Component, EventEmitter, Input, Output } from "@angular/core";
import { DatePipe, UpperCasePipe } from "@angular/common";
import { FormControl, ReactiveFormsModule } from "@angular/forms";
import { TaskCommentView } from "@models/task-comment";
import { ButtonComponent } from "../../../../shared/components/button/button.component";

@Component({
  selector: "app-task-comments",
  imports: [DatePipe, UpperCasePipe, ReactiveFormsModule, ButtonComponent],
  templateUrl: "./task-comments.component.html",
  styleUrl: "./task-comments.component.scss",
})
export class TaskCommentsComponent {
  @Input({ required: true }) comments: TaskCommentView[] = [];
  @Input() closed = false;
  @Input() closedAt: string | null = null;
  @Input() closedMessage = "Solicitação encerrada em:";
  @Input() closedBadge = "Solicitação Encerrada";
  @Input() submitting = false;
  @Output() commentSubmit = new EventEmitter<{
    message: string;
    files: File[];
  }>();

  messageControl = new FormControl("");
  attachedFiles: File[] = [];

  onFileSelect(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files) {
      this.attachedFiles = [...this.attachedFiles, ...Array.from(input.files)];
    }
    input.value = "";
  }

  removeFile(index: number) {
    this.attachedFiles.splice(index, 1);
  }

  submitComment() {
    if (this.submitting) return;
    const message = this.messageControl.value?.trim();
    if (!message) return;
    this.commentSubmit.emit({
      message,
      files: this.attachedFiles,
    });
    this.messageControl.reset("");
    this.attachedFiles = [];
  }
}
